import { Button, Col, Modal, Row } from "antd";
import { useMediaQuery } from "react-responsive";
import { AppboxLanguageSelect } from "../../components";
import { RocketOutlined } from "@ant-design/icons";
import UpgradeModal from "./UpgradeModal";
import { useState } from "react";
import { useLocalStorage } from "usehooks-ts";

export default function AppHeader({ }) {
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);
    const [user] = useLocalStorage("user", null);

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 771px)",
    });

    return (
        <>
            <Row
                style={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                }}>
                <Col>
                    <Button
                        type="primary"
                        disabled={user?.plan === "business"}
                        style={{ marginRight: "15px" }}
                        onClick={() => setShowUpgradeModal(true)}
                        icon={<RocketOutlined />}>
                        Upgrade
                    </Button>
                </Col>
                <Col style={{
                    paddingTop: isLargeScreen ? 0 : "5%",
                    display: "flex",
                    alignItems: "center",
                }}>
                    <AppboxLanguageSelect />
                </Col>
            </Row>
            <UpgradeModal open={showUpgradeModal} close={() => setShowUpgradeModal(false)} plan={user?.plan} old_subscription_type={user?.subscription_type} />
        </>

    );
}
